import { useDelayedState, useSetSearchParams } from '@nexelem/utils';
import { useEffect } from 'react';
import { useFiltersContext } from '../hooks';
import { FilterComponentBaseProps } from '../types/filter.types';
import { useSearchParams } from 'react-router-dom';
import { SearchChip } from '@nexelem/inputs';
import { get } from 'lodash';

type SearchFilterProps = Omit<FilterComponentBaseProps, 'value' | 'isMultiple'> & {
  placeholder: string;
  width?: string;
  saveToSearchParams?: boolean;
};

export const SearchInput = ({ path, register, placeholder, width, saveToSearchParams }: SearchFilterProps) => {
  const paramPath = saveToSearchParams ? `search-${path}` : `data[${path}][value]`;
  const [params] = useSearchParams();
  const { setSearchParams } = useSetSearchParams();
  const initialValue = params.get(paramPath) || '';

  const { onChange, filters } = useFiltersContext();

  const filterValue = get(filters, path, { value: '' });
  const currentValue = typeof filterValue.value === 'string' ? filterValue.value : initialValue;

  const [value, delayedValue, setValue] = useDelayedState(initialValue);

  useEffect(() => {
    register({
      path,
      value: initialValue,
      isMultiple: false,
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [path, register]);

  useEffect(() => {
    if (currentValue !== value) {
      setValue(currentValue);
    }
  }, [currentValue]);

  useEffect(() => {
    onChange(path, { value: delayedValue });
    saveToSearchParams && setSearchParams([{ key: paramPath, value: delayedValue }]);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [delayedValue, path]);

  return <SearchChip placeholder={placeholder} value={value} width={width} onChange={setValue} />;
};
